import { makeStyles, tokens, typographyStyles } from "@fluentui/react-components";

export const useWelcomeSectionStyles = makeStyles({
  flexColumnStyle: {
    display: "flex",
    flexDirection: "column",
  },
  flexCentered: {
    justifyContent: "center",
    justifyItems: "center",
    alignItems: "center",
  },
  textUpperCase: {
    textTransform: "uppercase",
  },
  fullWidth: {
    width: "100%",
  },
  logoContainer: {
    marginBottom: "50px",
  },
  headTitleContainer: {
    justifyItems: "flex-start",
    rowGap: "5px",
  },
  headTitleSmall: {
    color: "#757575",
    fontSize: "12.80px",
    fontWeight: 400,
    wordWrap: "break-word",
  },
  headTitleLarge: typographyStyles.title1,
  dividerContainer: {},
  optionDivider: {
    color: "#616161",
    fontSize: "12.80px",
    wordWrap: "break-word",
    margin: "10px 0px",
  },
  formContainer: {
    rowGap: "17px",
  },
  ssoBtn: {
    color: tokens.colorBrandBackground,
    height: "55px",
    textTransform: "uppercase",
    justifyContent: "center",
  },
});
